var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-empty-function */
import { classNames } from 'libs/react';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { wait } from 'libs/util/time';
import { Alert } from 'components/alert/Alert';
import { PresentStack } from 'components/util/PresentStack';
import { React } from 'libs/react';
import './AlertStack.scss';
/**
 * @component AlertStack
 * @since 1.0.0
 */
export function AlertStack(props) {
    const { style, persistence, presentClassName, dismissClassName, duration } = Object.assign({ style: 'normal', persistence: 4000, presentClassName: 'alert--present', dismissClassName: 'alert--dismiss', duration: 750 }, props);
    const presenter = useRef(null);
    const [length, setLength] = useState(0);
    const [presenting, setPresenting] = useState(false);
    const [dismissing, setDismissing] = useState(false);
    /**
     * @method onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        dismiss();
    }
    /**
     * @method present
     * @since 1.0.0
     * @hidden
     */
    function present(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const stack = presenter.current;
            if (stack == null) {
                return;
            }
            options = Object.assign({ style: 'success' }, options);
            if (options.delay) {
                yield wait(options.delay);
            }
            stack.present(React.createElement(Alert, { style: options.style, title: options.title, infos: options.infos, picto: options.picto, error: options.error, field: options.field, onClose: onClose }));
            setPresenting(true);
            setDismissing(false);
            setLength((length) => length + 1);
            setTimeout(dismiss, persistence);
        });
    }
    /**
     * @method dismiss
     * @since 1.0.0
     * @hidden
     */
    function dismiss() {
        return __awaiter(this, void 0, void 0, function* () {
            const stack = presenter.current;
            if (stack == null) {
                return;
            }
            stack.dismiss();
            setPresenting(false);
            setDismissing(true);
            setLength((length) => length - 1);
        });
    }
    const context = {
        present,
        dismiss
    };
    const className = classNames('alert-stack', 'alert-stack--' + style, { 'alert-stack--is-active': length }, { 'alert-stack--is-unused': length == 0 }, { 'alert-stack--is-presenting': presenting }, { 'alert-stack--is-dismissing': dismissing }, props.className);
    return (React.createElement(AlertStackContext.Provider, { value: context },
        props.children,
        React.createElement("div", { className: className },
            React.createElement(PresentStack, { ref: presenter, duration: duration, presentClassName: presentClassName, dismissClassName: dismissClassName }))));
}
/**
 * @component AlertStackContext
 * @since 1.0.0
 */
export const AlertStackContext = createContext({
    present() { },
    dismiss() { }
});
/**
 * @component useAlert
 * @since 1.0.0
 */
export function useAlert() {
    return useContext(AlertStackContext);
}
